<div class="flex flex-col gap-4 text-center font-['Roboto']">
  <!-- Todo: Tim: #may6 - still need correct image here -->
  <img
    src="assets/images/green-confirmation-circle.svg"
    alt="Green confirmation circle"
    class="size-10 mx-4 self-center"
  />
  <p class="text-lg font-bold">{{ getPageHeader() }}</p>
  <p>{{ getPageHeaderHelpText1() }}</p>
  <!-- Todo: Tim: #may6 - For MVP, WAIT and ALLOW will have the same help text -->
  <!-- <p *ngIf="getPageHeaderHelpText2()">{{ getPageHeaderHelpText2() }}</p> -->
   <!-- Todo: Tim: #may6 - get real spinner -->
  <img
    src="assets/images/spinner.gif"
    alt="Green confirmation circle"
    class="size-16 mx-4 self-center rounded-full bg-gray-200"
  />
  <p>{{ getRedirectText()}}</p>
</div>